import { AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { EmployeeStatusesService } from '../../employee-statuses/employee-statuses.service';
import { Subject } from 'rxjs';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-monitoring-work-interval',
  templateUrl: './monitoring-work-interval.component.html',
  styleUrls: ['./monitoring-work-interval.component.scss'],
  standalone: false,
})
export class MonitoringWorkIntervalComponent implements OnInit, OnDestroy, AfterViewInit {
  public moment = require('moment');
  private destroy$ = new Subject<void>();
  @Input() workInterval;
  @Input() ticketId;
  @Input() workday;
  @ViewChild('workInterval')
  workIntervalElement: ElementRef;

  constructor(
    private elementRef: ElementRef,
    private employeeStatusesService: EmployeeStatusesService
  ) {}

  ngOnInit() {
    this.employeeStatusesService.isAddData.subscribe((state: boolean) => {
      if (state) {
        this.setPosition();
      }
    });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.setPosition();
    }, 0);
  }

  setPosition() {
    if (!this.workInterval) {
      return;
    }

    let hoursStart = +this.moment(this.workInterval.int_begin).format('HH');
    let minutesStart = +this.moment(this.workInterval.int_begin).format('mm');
    let hoursEnd = +this.moment(this.workInterval.int_end).format('HH');
    let minutesEnd = +this.moment(this.workInterval.int_end).format('mm');
    let grandParent = this.elementRef.nativeElement.parentElement.parentElement;

    let childStarts = grandParent.querySelectorAll('div[id="ticket_' + this.ticketId + '_' + this.workday + '_' + hoursStart + '"]');
    let childEnds = grandParent.querySelectorAll('div[id="ticket_' + this.ticketId + '_' + this.workday + '_' + hoursEnd + '"]');

    let childStart = Array.prototype.find.call(childStarts,
      (child) => this.employeeStatusesService.isToday(child, this.workInterval.int_begin));
    let childEnd = Array.prototype.find.call(childEnds,
      (child) => this.employeeStatusesService.isToday(child, this.workInterval.int_end));

    if (childStart && childEnd) {
      setTimeout(() => {
        let s = (childStart.clientWidth / 60) * minutesStart;
        let e = (childEnd.clientWidth / 60) * minutesEnd;
        let w = childEnd.offsetLeft + e - (childStart.offsetLeft + s);

        let workInterval = this.elementRef.nativeElement.querySelector('.work-interval');
        workInterval.style.left = childStart.offsetLeft + s + 'px';
        workInterval.style.width = w + 'px';
      }, 4);
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
